// CONSTANTS
export const TEMPLATE_DETAILS_PATH = '/:section/:id/details';

// PATTERNS
export const BROWSE_PATTERN = '/(.*)/browse';
